<template>
  <Form :label-width="80">
    <FormItem label="适用范围">
      <Steps :current="current">
        <Step v-for="item in items" :title="item.value" @click.native="go(item.index)" :key="item.index"></Step>
      </Steps>
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: "filerange",
  data() {
    return {
      items: [{
          value: "中央",
          index: 0
        },
        {
          value: "四川",
          index: 1
        },
        {
          value: "成都",
          index: 2
        }
      ],
      current: 0,
    }
  },
  methods: {
    go(order) {
      this.current = order;
    },
  }
}

</script>
<style>
</style>
